module.exports = __webpack_public_path__ + "img/static-logo.141fe628.png";